import React, { useState, useEffect, useRef } from "react";
import {
  Page,
  Card,
  Text,
  DataTable,
  Button,
  InlineStack,
  BlockStack,
  TextField,
  Select,
  Box,
  ButtonGroup,
  Badge,
  ProgressBar,
  Modal,
  FormLayout,
  Toast,
  Spinner,
  InlineGrid,
  Image,
  Icon,
} from "@shopify/polaris";
import axios from "../../Assets/Lib/axios";
import { useNavigate } from "react-router-dom";
import { Result } from "postcss/lib/postcss";
import emptyListImage from "../../Assets/Images/emptyList.svg";
import { default as MyPagination } from "@material-ui/lab/Pagination";
import {
  ArrowDownIcon,
  ArrowUpIcon,
  CategoriesIcon,
  ChartLineIcon,
  EditIcon,
  ImagesIcon,
  ListBulletedFilledIcon,
  ListBulletedIcon,
  PlusCircleIcon,
  SearchResourceIcon,
  ViewIcon,
} from "@shopify/polaris-icons";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
const timelineButtons = [
  { label: "All", value: "All" },
  { label: "This month", value: "1" },
  { label: "3M", value: "2" },
  { label: "6M", value: "3" },
  { label: "12M", value: "4" },
];

const Goals = () => {
  const navigate = useNavigate();

  // -----------------------------
  // States
  // -----------------------------
  const [goals, setGoals] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const [search, setSearch] = useState("");
  const [priority, setPriority] = useState("All");
  const [typeFilter, setTypeFilter] = useState("All");
  const [status, setStatus] = useState("All");
  const [timeline, setTimeline] = useState("All");

  const [page, setPage] = useState(1);
  const [perPage] = useState(50);
  const [totalPages, setTotalPages] = useState(1);

  const [activeGoalId, setActiveGoalId] = useState(null);
  const [toastActive, setToastActive] = useState(false);
  const [toastContent, setToastContent] = useState("");

  const refBoolPage = useRef(true);

  // -----------------------------
  // Helpers
  // -----------------------------
  const activeGoal = goals?.find((g) => g.id === activeGoalId);

  const progressFromSubtasks = (subtasks) => {
    if (!subtasks?.length) return 0;
    const done = subtasks.filter((s) => String(s.status.id) === "3").length;
    console.log("done=", done);
    return Math.round((done / subtasks.length) * 100);
  };

  const priorityToBadge = (p) => {
    const tone = p === "P1" ? "critical" : p === "P2" ? "warning" : undefined;
    return (
      <InlineStack>
        <Badge tone={tone}>{p}</Badge>
      </InlineStack>
    );
  };

  const statusToBadge = (s) => {
    const tone =
      s === "Done"
        ? "success"
        : s === "Blocked"
        ? "critical"
        : s === "In progress"
        ? "warning"
        : undefined;
    return (
      <InlineStack>
        <Badge tone={tone}>{s}</Badge>
      </InlineStack>
    );
  };
  const [country, setCountry] = useState("");

  // -----------------------------
  // Fetch Goals
  // -----------------------------
  const fetchGoals = async () => {
    //setIsLoading(true);
    try {
      const params = new URLSearchParams();

      // pagination
      params.append("per_page", perPage);
      params.append("page", refBoolPage.current ? page : 1);

      // filters
      if (search) params.append("search", search);
      if (priority !== "All") params.append("filter[priority]", priority);
      if (typeFilter !== "All") params.append("filter[type]", typeFilter);
      if (status !== "All") params.append("filter[status]", status);
      if (timeline !== "All") params.append("filter[timeline]", timeline);
      if (country !== "") params.append("filter[country]", country);

      const response = await axios.get(`/goals`, { params });

      const data = response.data.data.data || [];
      console.log("goals=", data);
      const formattedGoals = data.map((goal) => ({
        ...goal,
        id: goal.id,
        priority: goal.priority?.description || "",
        type: goal.type?.description || "",
        status: goal.status?.description || "",
        timeline: goal.timeline?.description || "",
      }));
      console.log("formattedGoals=", formattedGoals);
      setGoals(formattedGoals);
      setTotalPages(response.data.data.total || 1);
    } catch (error) {
      console.error(error);
    }
    setIsLoading(false);
  };
  const handleChangePage = (event, value) => {
    refBoolPage.current = true;
    setPage(value);
  };
  useEffect(() => {
    fetchGoals();
  }, [page, search, priority, typeFilter, status, timeline, country]);

  // -----------------------------
  // Handlers
  // -----------------------------
  const [ts, setTs] = useState("");
  const handleAddGoal = () => navigate("/admin/goals/new");
  const handleUp = (param) => {
    const bodyObj = {
      direction: "up",
    };
    axios
      .post(`/goals/${param}/sort`, bodyObj)
      .then((res) => {
        fetchGoals();
      })
      .catch((err) => console.log(""));
  };
  const handleDown = (param) => {
    const bodyObj = {
      direction: "down",
    };
    axios
      .post(`/goals/${param}/sort`, bodyObj)
      .then((res) => {
        fetchGoals();
      })
      .catch((err) => console.log(""));
  };
  // -----------------------------
  // DataTable Rows
  // -----------------------------

  // Make each goal row cell include a data-row-index attribute
  const goalRows = goals?.map((g, index) => [
    <div data-row-index={index}>
      {g.goal?.length > 50 ? g.goal.slice(0, 50) + "..." : g.goal}
    </div>,
    <div data-row-index={index}>{g.owner}</div>,
    <div data-row-index={index}>{priorityToBadge(g.priority)}</div>,
    <div data-row-index={index}>{g.type}</div>,
    <div data-row-index={index}>{g.timeline}</div>,
    <div data-row-index={index}>
      <ProgressBar progress={progressFromSubtasks(g.tasks)} size="small" />
    </div>,
    <div data-row-index={index}>{statusToBadge(g.status)}</div>,
    <div data-row-index={index}>
      <ButtonGroup>
        <Button
          onClick={(e) => {
            e.stopPropagation();
            handleUp(g.id);
          }}
          icon={ArrowUpIcon}
        />
        <Button
          onClick={(e) => {
            e.stopPropagation();
            handleDown(g.id);
          }}
          icon={ArrowDownIcon}
        />
        <Button
          onClick={(e) => {
            e.stopPropagation();
            navigate(`/admin/goals/${g.id}`);
          }}
          icon={EditIcon}
        >
          Edit
        </Button>
      </ButtonGroup>
    </div>,
  ]);

  // ✅ Add this after defining goalRows
  useEffect(() => {
    const cells = document.querySelectorAll(".Polaris-DataTable__Cell");

    const handleClick = (e) => {
      // 🔸 Ignore clicks inside buttons, icons, or interactive elements
      if (
        e.target.closest("button") ||
        e.target.closest("a") ||
        e.target.closest('[role="button"]') ||
        e.target.closest(".Polaris-Button")
      ) {
        return; // skip opening modal
      }

      const rowIndex =
        e.currentTarget.querySelector("[data-row-index]")?.dataset.rowIndex;
      if (rowIndex !== undefined) {
        setActiveGoalId(goals[Number(rowIndex)].id);
      }
    };

    cells.forEach((cell) => {
      cell.removeEventListener("click", handleClick);
      cell.addEventListener("click", handleClick);
    });

    return () => {
      cells.forEach((cell) => cell.removeEventListener("click", handleClick));
    };
  }, [goalRows]);

  // const goalRows = goals?.map((g) => [
  //   <Text as="span" fontWeight="semibold">
  //     {g.goal}
  //   </Text>,
  //   g.owner,
  //   priorityToBadge(g.priority),
  //   g.type,
  //   g.timeline,
  //   <Box minWidth="140px">
  //     <ProgressBar progress={progressFromSubtasks(g.tasks)} size="small" />
  //   </Box>,
  //   statusToBadge(g.status),
  //   <ButtonGroup>
  //     <Button onClick={() => handleUp(g.id)} icon={ArrowUpIcon}></Button>
  //     <Button onClick={() => handleDown(g.id)} icon={ArrowDownIcon}></Button>
  //     {/* <Button
  //       onClick={() => navigate(`/admin/goals/${g.id}/tasks`)}
  //       icon={CategoriesIcon}
  //     >
  //       Subtasks
  //     </Button> */}
  //     {/* <Button onClick={() => setActiveGoalId(g.id)} icon={ViewIcon}>
  //       View Details
  //     </Button> */}
  //     <Button onClick={() => navigate(`/admin/goals/${g.id}`)} icon={EditIcon}>
  //       Edit
  //     </Button>
  //   </ButtonGroup>,
  // ]);
  const [countryButtons, setCountryButtons] = useState([]);
  useEffect(() => {
    axios
      .get("/settings/countries")
      .then((res) => {
        const countriesData = res?.data?.data || [];
        const options = [
          { label: "All", value: "" },
          { label: "Mutual", value: "All" },
          ...countriesData.map((country) => ({
            label: country.name,
            value: country.name,
            flag: country.flag,
          })),
        ];
        setCountryButtons(options);
        // setCountry(options?.[0]);
      })
      .catch((err) => console.log(err));
  }, []);
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [lightboxImages, setLightboxImages] = useState([]);
  return goals ? (
    <Page
      title="Goals"
      fullWidth
      primaryAction={
        <Button variant="primary" onClick={handleAddGoal} icon={PlusCircleIcon}>
          Add Goal
        </Button>
      }
      secondaryActions={
        <ButtonGroup>
          <Button
            onClick={() => navigate("/admin/goals/timeline")}
            icon={ListBulletedIcon}
          >
            Timeline
          </Button>
        </ButtonGroup>
      }
    >
      {/* ----------------- Filters ----------------- */}

      <Card>
        <BlockStack gap="500">
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center", // ✅ keeps both sides aligned vertically
              flexWrap: "wrap",
              gap: "1rem",
              rowGap: "1.5rem",
            }}
          >
            {/* 🔹 Left side: Filters + Timeline buttons */}
            <InlineStack gap="300" wrap align="center">
              <Box minWidth="260px">
                <TextField
                  label="Search goals"
                  value={search}
                  onChange={setSearch}
                  autoComplete="off"
                  placeholder="Search by goal"
                />
              </Box>

              <Select
                label="Priority"
                value={priority}
                onChange={setPriority}
                options={[
                  { label: "All", value: "All" },
                  { label: "P1", value: "1" },
                  { label: "P2", value: "2" },
                  { label: "P3", value: "3" },
                ]}
              />

              <Select
                label="Type"
                value={typeFilter}
                onChange={setTypeFilter}
                options={[
                  { label: "All", value: "All" },
                  { label: "Tactical", value: "1" },
                  { label: "Strategic", value: "2" },
                  { label: "Marketing", value: "3" },
                  { label: "Operational", value: "4" },
                  { label: "Technical", value: "5" },
                ]}
              />

              <Select
                label="Status"
                value={status}
                onChange={setStatus}
                options={[
                  { label: "All", value: "All" },
                  { label: "Not Started", value: "1" },
                  { label: "In Progress", value: "2" },
                  { label: "Blocked", value: "3" },
                  { label: "Completed", value: "4" },
                ]}
              />
              <Select
                label="Timeline"
                value={timeline}
                onChange={setTimeline}
                options={[
                  { label: "All", value: "All" },
                  { label: "This month", value: "1" },
                  { label: "3M", value: "2" },
                  { label: "6M", value: "3" },
                  { label: "12M", value: "4" },
                ]}
              />

              {/* 🔹 Timeline buttons (now visually aligned with selects) */}
              {/* <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "flex-end",
                  height: "100%", // 👈 helps center the group
                }}
              >
                <Text
                  as="span"
                  variant="bodyMd"
                  fontWeight="medium"
                  style={{ marginBottom: "0.4rem" }}
                >
                  Timeline
                </Text>
                <ButtonGroup segmented>
                  {timelineButtons.map((t) => (
                    <Button
                      key={t.value}
                      pressed={timeline === t.value}
                      onClick={() => setTimeline(String(t.value))}
                    >
                      {t.label}
                    </Button>
                  ))}
                </ButtonGroup>
              </div> */}
            </InlineStack>

            {/* 🔹 Right side: Country buttons */}
            <Box display="flex">
              <ButtonGroup segmented>
                {countryButtons.map((t) => (
                  <Button
                    key={t.value}
                    pressed={country === t.value}
                    onClick={() => setCountry(String(t.value))}
                  >
                    {t.flag && (
                      <img
                        src={t.flag}
                        alt={t.flag}
                        style={{ width: 20, marginRight: 6 }}
                      />
                    )}
                    {t.label}
                  </Button>
                ))}
              </ButtonGroup>
            </Box>
          </div>
        </BlockStack>
      </Card>

      {/* <Card>
        <BlockStack gap="500">
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-start",
              flexWrap: "wrap",
              gap: "1rem",
            }}
          >
            <InlineStack gap="300" wrap>
              <Box minWidth="260px">
                <TextField
                  label="Search goals"
                  value={search}
                  onChange={setSearch}
                  autoComplete="off"
                />
              </Box>

              <Select
                label="Priority"
                value={priority}
                onChange={setPriority}
                options={[
                  { label: "All", value: "All" },
                  { label: "P1", value: "1" },
                  { label: "P2", value: "2" },
                  { label: "P3", value: "3" },
                ]}
              />

              <Select
                label="Type"
                value={typeFilter}
                onChange={setTypeFilter}
                options={[
                  { label: "All", value: "All" },
                  { label: "Tactical", value: "1" },
                  { label: "Strategic", value: "2" },
                  { label: "Marketing", value: "3" },
                  { label: "Operational", value: "4" },
                  { label: "Technical", value: "5" },
                ]}
              />

              <Select
                label="Status"
                value={status}
                onChange={setStatus}
                options={[
                  { label: "All", value: "All" },
                  { label: "Not Started", value: "1" },
                  { label: "In Progress", value: "2" },
                  { label: "Blocked", value: "3" },
                  { label: "Completed", value: "4" },
                ]}
              />
            </InlineStack>

            <div style={{ marginTop: "1.5rem" }}>
              <ButtonGroup segmented>
                {timelineButtons.map((t) => (
                  <Button
                    key={t.value}
                    pressed={timeline === t.value}
                    onClick={() => setTimeline(String(t.value))}
                  >
                    {t.label}
                  </Button>
                ))}
              </ButtonGroup>
            </div>
          </div>
        </BlockStack>
      </Card> */}

      {/* ----------------- Table ----------------- */}
      <div className="mt-2">
        <Card padding={"0"}>
          {isLoading ? (
            <div className="spinnerContainer">
              <div className="vertical-center">
                <Spinner size="large" />
              </div>
            </div>
          ) : goals?.length ? (
            <FormLayout>
              <div className="clickable-table">
                <DataTable
                  columnContentTypes={[
                    "text",
                    "text",
                    "text",
                    "text",
                    "text",
                    "text",
                    "text",
                    "text",
                  ]}
                  headings={[
                    "Goal",
                    "Owner",
                    "Priority",
                    "Type",
                    "Timeline",
                    "Progress",
                    "Status",
                    "",
                  ]}
                  rows={goalRows}
                  verticalAlign="middle"
                  stickyHeader
                  footerContent={
                    goalRows?.length &&
                    `Showing ${goalRows.length} of ${totalPages} results`
                  }
                />
              </div>
              {Math.ceil(totalPages / perPage) >= 2 && (
                <div
                  style={{
                    paddingTop: "10px",
                    textAlign: "center",
                    paddingBottom: "10px",
                  }}
                >
                  <MyPagination
                    count={Math.ceil(totalPages / perPage)}
                    page={page}
                    onChange={handleChangePage}
                    size="large"
                  />
                </div>
              )}
            </FormLayout>
          ) : (
            <div
              style={{
                display: "flex",
                justifyContent: "middle",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <div style={{ width: "25%" }}>
                <img src={emptyListImage}></img>
              </div>
              <div className="mb-3">
                <Text variant="headingLg" as="h5" color="subdued">
                  No results found
                </Text>
              </div>
              <br />
            </div>
          )}
        </Card>
      </div>

      {/* ----------------- Goal Details Modal ----------------- */}
      <Modal
        open={!!activeGoal}
        onClose={() => setActiveGoalId(null)}
        title={activeGoal ? activeGoal.title : "Goal details"}
        primaryAction={{
          content: "Close",
          onAction: () => setActiveGoalId(null),
        }}
      >
        <Modal.Section>
          {activeGoal && (
            <BlockStack gap="300">
              <Card>{activeGoal.goal}</Card>
              <InlineGrid columns={{ xs: 1, sm: 2 }} gap="300">
                <Card subdued>
                  <BlockStack padding="300" gap="200">
                    <div className="iconLabel">
                      <Icon source={SearchResourceIcon} tone="base" />
                      <Text as="h3" variant="headingMd">
                        Overview
                      </Text>
                    </div>
                    <InlineGrid columns={{ xs: 1, sm: 2 }} gap="200">
                      <BlockStack>
                        <Text tone="subdued">Owner</Text>
                        <Text>{activeGoal.owner}</Text>
                      </BlockStack>
                      <BlockStack>
                        <Text tone="subdued">Priority</Text>
                        {priorityToBadge(activeGoal.priority)}
                      </BlockStack>
                      <BlockStack>
                        <Text tone="subdued">Type</Text>
                        <Text>{activeGoal.type}</Text>
                      </BlockStack>
                      <BlockStack>
                        <Text tone="subdued">Timeline</Text>
                        <Text>{activeGoal.timeline}</Text>
                      </BlockStack>
                      <BlockStack>
                        <Text tone="subdued">Status</Text>
                        {statusToBadge(activeGoal.status)}
                      </BlockStack>
                    </InlineGrid>
                    {(activeGoal.baseline || activeGoal.target) && (
                      <InlineStack gap="300">
                        {activeGoal.baseline && (
                          <Badge tone="attention">
                            Baseline: {activeGoal.baseline}
                          </Badge>
                        )}
                        {activeGoal.target && (
                          <Badge tone="success">
                            Target: {activeGoal.target}
                          </Badge>
                        )}
                      </InlineStack>
                    )}
                  </BlockStack>
                </Card>
                <Card subdued>
                  <BlockStack padding="300" gap="200">
                    <div className="iconLabel">
                      <Icon source={ChartLineIcon} tone="base" />
                      <Text as="h3" variant="headingMd">
                        Progress
                      </Text>
                    </div>
                    <ProgressBar
                      progress={progressFromSubtasks(activeGoal.tasks)}
                    />
                  </BlockStack>
                </Card>
              </InlineGrid>

              {activeGoal?.tasks?.length ? (
                <Card>
                  <BlockStack padding="300" gap="300">
                    <div className="iconLabel">
                      <Icon source={CategoriesIcon} tone="base" />
                      <Text as="h3" variant="headingMd">
                        Subtasks
                      </Text>
                    </div>
                    <BlockStack gap="200">
                      {activeGoal?.tasks?.map((st) => (
                        <InlineStack
                          key={st.id}
                          align="space-between"
                          blockAlign="center"
                        >
                          <Text as="span">{st.title}</Text>
                          <Button
                            pressed={String(st.status.id) === "3"}
                            onClick={async () => {
                              try {
                                const formData = new FormData();
                                formData.append("_method", "PATCH");
                                const newStatus =
                                  String(st.status.id) === "3" ? "2" : "3";
                                formData.append("status", newStatus);
                                formData.append("title", st.title);

                                await axios.post(
                                  `/goals/${activeGoal.id}/tasks/${st.id}`,
                                  formData
                                );

                                // Update local state so modal reflects change immediately
                                setGoals((prevGoals) =>
                                  prevGoals.map((g) => {
                                    if (g.id !== activeGoal.id) return g;
                                    return {
                                      ...g,
                                      tasks: g.tasks.map((t) =>
                                        t.id === st.id
                                          ? {
                                              ...t,
                                              status: {
                                                id: Number(newStatus),
                                                description:
                                                  newStatus === "3"
                                                    ? "Done"
                                                    : "In Progress",
                                              },
                                            }
                                          : t
                                      ),
                                    };
                                  })
                                );
                              } catch (error) {
                                console.error("Failed to update task:", error);
                              }
                            }}
                          >
                            {String(st.status.id) === "3" ? "Undone" : "Done"}
                          </Button>
                        </InlineStack>
                      ))}
                    </BlockStack>
                  </BlockStack>
                </Card>
              ) : null}

              {activeGoal?.screenshots?.length ? (
                <Card>
                  <BlockStack padding="300" gap="300">
                    <div className="iconLabel">
                      <Icon source={ImagesIcon} tone="base" />
                      <Text as="h3" variant="headingMd">
                        Screenshots
                      </Text>
                    </div>
                    <BlockStack gap="200">
                      <InlineStack gap="200" wrap>
                        {activeGoal?.screenshots?.map((img, index) => (
                          <img
                            key={index}
                            src={img}
                            alt={`image-${index}`}
                            style={{
                              width: "80px",
                              height: "80px",
                              objectFit: "cover",
                              borderRadius: "6px",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              setLightboxImages(
                                activeGoal.screenshots.map((url) => ({
                                  src: url,
                                }))
                              );
                              setLightboxOpen(true);
                            }}
                          />
                        ))}
                      </InlineStack>
                    </BlockStack>
                  </BlockStack>
                </Card>
              ) : null}
            </BlockStack>
          )}
        </Modal.Section>
      </Modal>

      {toastActive && (
        <Toast content={toastContent} onDismiss={() => setToastActive(false)} />
      )}
      {lightboxOpen && (
        <Lightbox
          open={lightboxOpen}
          close={() => setLightboxOpen(false)}
          slides={lightboxImages}
        />
      )}
    </Page>
  ) : (
    <div className="spinnerContainer">
      <div className="vertical-center">
        <Spinner size="large" />
      </div>
    </div>
  );
};

export default Goals;
